import { createContext } from 'react';

type UserInfo = {
  isExternal: boolean;
  isOrganization: boolean;
  isPerson: boolean;
  userLoaded: boolean;
};

export interface ICurrentUserInfoContext {
  userInfo: UserInfo;
}

export const CurrentUserInfoContext = createContext<ICurrentUserInfoContext>({
  userInfo: {
    isExternal: false,
    isOrganization: false,
    isPerson: false,
    userLoaded: false,
  },
});
